export default __webpack_public_path__ + "static/media/01.c78bf2f5.webp";